import { ChakraFlex, SkeletonLoader } from '@equip.health/ui';

interface SkeletonLoaderListProps {
  direction?: 'row' | 'column';
  gap?: string;
  id: string;
  itemCount?: number;
  itemHeight: string;
  itemWidth?: string;
}

// TODO: Migrate this component to equip-ui (https://teamequip.atlassian.net/browse/PT-3118)

const SkeletonLoaderList = ({
  direction = 'row',
  gap = '12px',
  id,
  itemCount = 3,
  itemHeight,
  itemWidth = '100%',
}: SkeletonLoaderListProps) => {
  const itemPrefix = `${id}__item`;
  return (
    <ChakraFlex
      direction={direction}
      gap={gap}
      id={id}
      sx={{
        [`& > [id^="${itemPrefix}"]`]: { borderRadius: '12px' },
      }}
    >
      {Array.from({ length: itemCount }).map((_, i) => (
        <SkeletonLoader id={`${itemPrefix}--${i}`} isLoaded={false} key={i}>
          <ChakraFlex height={itemHeight} width={itemWidth} />
        </SkeletonLoader>
      ))}
    </ChakraFlex>
  );
};

export default SkeletonLoaderList;
